import { Navigate, Outlet, useLocation, useOutletContext } from "react-router-dom";

// The apply route is reachable only from a scheme card/details page, which
// passes the scheme in router state. This has to gate ABOVE FarmerContextRoute:
// otherwise a direct visit asks the agent to verify a farmer first, and only
// then discovers there is no scheme to apply for.
export default function RequireSchemeContext() {
  const location = useLocation();
  const outletContext = useOutletContext();
  if (!location.state?.schemeId) {
    return <Navigate to={`${window.contextPath}/schemes`} replace />;
  }
  return <Outlet context={outletContext} />;
}
